import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useEffect } from "react";
import { useLanguage } from "@/i18n";

export const Layout = () => {
  const location = useLocation();
  const { lang } = useLanguage();
  
  // Determine page type for header transparency
  const isHomePage = location.pathname === "/" || location.pathname === "/en";
  const isFilosofiaPage = location.pathname === "/filosofia" || location.pathname === "/en/philosophy";
  const isProyectosPage = location.pathname === "/proyectos" || location.pathname === "/en/projects";
  const isPublicidadPage = location.pathname === "/publicidad" || location.pathname === "/en/advertising";
  const isLegalPage = location.pathname === "/legal" || location.pathname === "/en/legal";
  
  // Pages with full-bleed imagery need transparent header
  const hasTransparentHeader = isHomePage || isFilosofiaPage || isProyectosPage || isPublicidadPage || isLegalPage;

  // Set document lang attribute and scroll to top on route change
  useEffect(() => {
    document.documentElement.lang = lang;
    window.scrollTo(0, 0);
  }, [location.pathname, lang]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header isTransparent={hasTransparentHeader} />
      <main className="flex-1">
        <Outlet />
      </main>
      {/* Only show footer on pages that aren't full-bleed imagery */}
      {!isFilosofiaPage && <Footer />}
    </div>
  );
};
